module.exports = __webpack_public_path__ + "img/9788960533868.666375d1.jpg";